<template>
	<section class="section job-collections bg-white">
		<div class="container mx-auto flex flex-wrap items-center">

      <div class="section-title__wrapper pl-4">
				<h3 class="section-title">Job Collections</h3>
				<p class="pr-4">Need some inspiration? Here are some handpicked collections to kickstart your job search</p>
			</div>
			<div class="section-btn__wrapper pl-4 pr-4">
				<a class="btn btn-blue-light uppercase" href="/search/collections">View all</a>
			</div>

      <block-collection-cards :hits="3"></block-collection-cards>

		</div>
	</section>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
	}
</script>
